import { render } from "./RecensementUsager.vue?vue&type=template&id=4a67d7f2&scoped=true&ts=true"
import script from "./RecensementUsager.vue?vue&type=script&lang=ts"
export * from "./RecensementUsager.vue?vue&type=script&lang=ts"

import "./RecensementUsager.vue?vue&type=style&index=0&id=4a67d7f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a67d7f2"]])

export default __exports__